<template>
  <div>
    <el-dialog :close-on-click-modal="false"
        title="报名表"
        :visible.sync="addsign"
        :before-close="addProClose"
        width="105.5rem"
        center
      >
        <el-divider></el-divider>
        <div class="button_title">
            <span> <span>*</span> 题型：</span>
            <div @click="addQuestion('1')">单选</div>
            <div @click="addQuestion('2')">多选</div>
            <div @click="addQuestion('3')">下拉</div>
            <!-- <div @click="addQuestion('4')">多级下拉</div> -->
            <div @click="addQuestion('5')">填空</div>
            <div @click="addQuestion('6')">多项填空</div>
        </div>
        <div class="box">
            <div class="box_btns" v-if="arr.length==0">
                <img src="@/assets/zhi.png" alt="">
                <span>点击题型</span>
            </div>
            <div class="box_dan" v-for="(item,index) in arr" :key="index">
                <div v-if="item.question_type==1">
                  <div class="box_dan_title">
                   <span>*{{index+1}}：</span>
                   <el-input placeholder="请选择一个选项|" v-model="item.question_name"></el-input>
                   <span>必答题</span>
                   <el-switch
                      v-model="item.require_flag">
                   </el-switch>
                  </div>
                  <div class="box_dan_content"  >
                      <div class="content_one" v-for="(itm,index) in item.option" :key="index">
                        <el-radio v-model="radio"></el-radio>
                        <el-input placeholder="选项1" v-model="item.option[index]"></el-input>
                        <div class="content_one_img" @click="deletes(item.option)" v-if="item.option.length>2&&item.option.length==index+1">-</div>
                      </div>
                  </div>
                  <div class="form_btns">
                      <div @click="addremind(item.option)">
                        <img src="@/assets/add.png" alt="">
                        <span>添加选项</span>
                      </div>
                      <div @click="detele(index)"> 
                        <img src="@/assets/dete.png" alt="">
                        <span>删除</span>
                      </div>
                  </div>
                </div>
                <div v-if="item.question_type==2">
                  <div class="box_dan_title">
                   <span>*{{index+1}}：</span>
                   <el-input placeholder="请选择一个选项|" v-model="item.question_name"></el-input>
                   <span>必答题</span>
                   <el-switch
                      v-model="item.require_flag">
                   </el-switch>
                  </div>
                  <div class="box_dan_content"  >
                      <div class="content_one" v-for="(itm,index) in item.option" :key="index">
                        <el-checkbox ></el-checkbox>
                        <el-input placeholder="选项1" v-model="item.option[index]"></el-input>
                        <div class="content_one_img" @click="deletes(item.option)" v-if="item.option.length>2&&item.option.length==index+1">-</div>
                      </div>
                  </div>
                  <div class="form_btns">
                      <div @click="addremind(item.option)">
                        <img src="@/assets/add.png" alt="">
                        <span>添加选项</span>
                      </div>
                      <div @click="detele(index)"> 
                        <img src="@/assets/dete.png" alt="">
                        <span>删除</span>
                      </div>
                  </div>
                </div>
                <div v-if="item.question_type==3">
                  <div class="box_dan_title">
                   <span>*{{index+1}}：</span>
                   <el-input placeholder="请选择一个选项|" v-model="item.question_name"></el-input>
                   <span>必答题</span>
                   <el-switch
                      v-model="item.require_flag">
                   </el-switch>
                  </div>
                  <div class="box_dan_content"  >
                      <div class="content_one" v-for="(itm,index) in item.option" :key="index">
                        <img src="@/assets/select.png" alt="">
                        <el-input placeholder="选项1" v-model="item.option[index]"></el-input>
                        <div class="content_one_img" @click="deletes(item.option)" v-if="item.option.length>2&&item.option.length==index+1" >-</div>
                      </div>
                  </div>
                  <div class="form_btns">
                      <div @click="addremind(item.option)">
                        <img src="@/assets/add.png" alt="">
                        <span>添加选项</span>
                      </div>
                      <div @click="detele(index)"> 
                        <img src="@/assets/dete.png" alt="">
                        <span>删除</span>
                      </div>
                  </div>
                </div>
                <div v-if="item.question_type==5">
                  <div class="box_dan_title">
                    <span>*{{index+1}}：</span>
                    <el-input placeholder="请选择一个选项|" v-model="item.question_name"></el-input>
                    <span>必答题</span>
                    <el-switch
                        v-model="item.require_flag">
                    </el-switch>
                  </div>
                  <div class="input_textare">
                    填写者内容输入区
                  </div>
                  <div class="form_btns" style="margin:2rem 0 0 1rem;">
                      <div @click="detele(index)"> 
                        <img src="@/assets/dete.png" alt="">
                        <span>删除</span>
                      </div>
                  </div>
                </div>
                <div v-if="item.question_type==6">
                  <div class="box_dan_title">
                    <span>*{{index+1}}：</span>
                    <el-input placeholder="请选择一个选项|" v-model="item.question_name"></el-input>
                    <span>必答题</span>
                    <el-switch
                        v-model="item.require_flag">
                    </el-switch>
                  </div>
                  <div v-for="(itm,i) in item.option" :key="i">
                    <div class="text_input">
                      <el-input  placeholder="填空1" v-model="item.option[i]"></el-input>
                      <div class="content_one_img" @click="deletes(item.option)" v-if="item.option.length>2&&item.option.length==i+1">-</div>
                    </div>
                    <div class="input_textare">
                      填写者内容输入区
                    </div>
                  </div>
                  <div class="form_btns" style="margin:2rem 0 0 1rem;">
                      <div @click="addremind(item.option)">
                        <img src="@/assets/add.png" alt="">
                        <span>添加选项</span>
                      </div>
                      <div @click="detele(index)"> 
                        <img src="@/assets/dete.png" alt="">
                        <span>删除</span>
                      </div>
                  </div>
                </div>
            </div>
            <div class="buttom_div">
                <div>清空</div>
                <!-- <div>确认保存</div> -->
                <div @click="btns">确认发布</div>
            </div>
        </div>
    </el-dialog>
    <el-dialog :close-on-click-modal="false"
        title="编辑选项"
        :visible.sync="addoption"
        :before-close="optionProClose"
        width="130rem"
        center
      >
        <el-divider></el-divider>
        <div class="edit_box">
          <div>
              <span>一级选项</span>
              <div class="edit_box_select">
                 <div>
                    <img src="@/assets/select.png" alt="">
                    <el-select v-model="value" placeholder="选项" disabled>
                          <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                    </el-select>
                 </div>
                 <div>
                    <img src="@/assets/select.png" alt="">
                    <el-select v-model="value" placeholder="选项" disabled>
                          <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                    </el-select>
                 </div>
              </div>
              <div class="edit_box_btn">
                <div >
                        <img src="@/assets/add.png" alt="">
                        <span>添加选项</span>
                </div>
                <div >
                          <img src="@/assets/add.png" alt="">
                          <span>添加其他</span>
                </div>
              </div>
          </div>
          <div>
            <span>二级选项</span>
            <div class="edit_box_btn">
                <div >
                        <img src="@/assets/add.png" alt="">
                        <span>添加选项</span>
                </div>
                <div >
                          <img src="@/assets/add.png" alt="">
                          <span>添加其他</span>
                </div>
            </div>
          </div>
          <div>
            <span>三级选项</span>
            <div class="edit_box_btn">
                <div >
                        <img src="@/assets/add.png" alt="">
                        <span>添加选项</span>
                </div>
                <div >
                          <img src="@/assets/add.png" alt="">
                          <span>添加其他</span>
                </div>
            </div>
          </div>
          <div>
            <span>四级选项</span>
            <div class="edit_box_btn">
                <div >
                        <img src="@/assets/add.png" alt="">
                        <span>添加选项</span>
                </div>
                <div >
                          <img src="@/assets/add.png" alt="">
                          <span>添加其他</span>
                </div>
            </div>
          </div>
        </div>
        <div class="buttom_div">
          <div>清空</div>
          <div>确认保存</div>
        </div>
    </el-dialog>
  </div>
</template>
<script>
import {Message} from 'element-ui'
export default {
  data(){
    return{
      addoption:false,
      addsign:false,
      value1:'',
      radio:'',
      checked:'',
      value:'',
      options: [{
          value: '选项1',
          label: '黄金糕'
        }, {
          value: '选项2',
          label: '双皮奶'
        }, {
          value: '选项3',
          label: '蚵仔煎'
        }, {
          value: '选项4',
          label: '龙须面'
        }, {
          value: '选项5',
          label: '北京烤鸭'
        }],
      arr:[
       
      ],
      id:''
    }
  },
  methods:{
    deletes(item){
      item.pop()
    },
    btns(){
      this.arr.map((item,index)=>{
        console.log(this.id,item)
        if(this.id!=''){
          item.actid = this.id
        }
        if(item.require_flag==true){
          item.require_flag = 1
        }else{
          item.require_flag = 2
        }
        item.question_sort = 1+index
      })
      this.MethodPost(
          "http://jhyapi.softykt.cn/member/activity/createQuestionnaire",
            this.arr
          ).then((res) => {
            if(res.data.code=='666'){
                Message.success('保存成功')
                this.addsign = false
                this.$emit('close')
            }
          })
    },
    detele(i){
      this.arr.splice(i,1)
    },
    addQuestion(i){
      switch(i) {
        case '1':
            this.arr.push({
                actid:this.id,
                question_name:'',
                question_type:'1',
                question_sort:i,
                require_flag:'1',
                option:[
                  '',''
                ]
            })
            break;
        case '2':
            this.arr.push({
                actid:this.id,
                question_name:'',
                question_type:'2',
                question_sort:i,
                require_flag:'1',
                option:[
                '',''
                ]
            })
            break;
          case '3':
            this.arr.push({
                actid:this.id,
                question_name:'',
                question_type:'3',
                question_sort:i,
                require_flag:'1',
                option:[
                '',''
                ]
            })
            break;
          case '4':
            this.arr.push({
                actid:this.id,
                question_name:'',
                question_type:'4',
                question_sort:i,
                require_flag:'1',
                option:[
                '',''
                ]
            })
            break;
          case '5':
            this.arr.push({
                actid:this.id,
                question_name:'',
                question_type:'5',
                question_sort:i,
                require_flag:'1',
                option:[
                '',''
                ]
            })
            break;
          case '6':
            this.arr.push({
                actid:this.id,
                question_name:'',
                question_type:'6',
                question_sort:i,
                require_flag:'1',
                option:[
                '',''
                ]
            })
            break;
        default:
      } 
    },
    addremind(item){
      item.push('')
    },
    // 关闭编辑选项
    optionProClose(){
      this.addsign = true
      this.addoption = false
    },
    // 打开编辑选项
    addOptions(){
      this.addsign = false
      this.addoption = true
    },
    pxFn(id){
      this.id = id
      let data = {
        actid:id
      }
      this.MethodPost(
          "http://jhyapi.softykt.cn/member/activity/QuestionnaireDetail",
            data
          ).then(res=>{
            console.log(res)
            if(res.data.code==666){
              // this.arr = res.data.list
              // this.arr.map(item=>{
              //   item.actid = this.id
              // })
              res.data.list.map(item=>{
                item.op = item.option
                item.option = []
                this.arr.push(item)
              })
              this.arr.map(item=>{
                console.log(item)
                item.op.map(itm=>{
                  item.option.push(itm.option_name)
                })
              })
            }
          })
      this.addsign = true
    },
    addProClose(){
      this.addsign = false
      this.$emit('close')
    }
  }
}
</script>
<style scoped lang="less">
.button_title{
  display: flex;
  align-items: center;
  >div{
    padding: 1rem 2rem;
    box-sizing: border-box;
    border-radius: 0.4rem;
    background: #246DEB;
    margin-right: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-size: 1.4rem;
    cursor: pointer;
  }
  span{
    color: #666666;
    font-size: 1.4rem;
    span{
      color: #FF4D4F;
    }
  }
}
.box{
  margin-left: 5rem;
  margin-top: 2rem;
  .box_btns{
      width:100%;
      height: 15rem;
      border: 1px dashed #E5E5EA;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      img{
        width: 1.6rem;
        height: 1.9rem;
      }
      span{
        margin-left: 1.2rem;
        color: #666666;
        font-size: 1.4rem;
      }
  }
  .box_dan{
    width: 100%;
    padding: 2rem;
    box-sizing: border-box;
    background: #F9F9F9;
    border: 1px solid #246DEB; 
    margin-bottom: 2rem;
    border-radius: 0.4rem; 
    .box_dan_title{
      display: flex;
      align-items: center;
      .el-input{
        width: 75rem;
      }
      span{
        &:nth-child(1){
          font-size: 1.4rem;
          color: #666666;
          span{
            color: #FF4D4F;
          }
        }
        &:nth-child(3){
          margin: 0 2rem;
        }
      }
    }
    .flex_center{
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .el-input{
          width: 36rem !important;
        }
        .content_one{
          width: 50%;
        }
    }
    .box_dan_content{
      margin-left: 3rem;
      .content_one{
        margin-top: 2rem;
        display: flex;
        align-items: center;
        img{
          width: 1.7rem;
          height: 1.3rem;
          margin-right: 1.2rem;
        }
        .el-input{
          width: 85rem;
        }
        .el-radio{
          margin-right: 1.2rem;
        }
        .el-checkbox{
          margin-right: 1.2rem;
        }
      }
      .content_one_img{
        cursor: pointer;
        width: 1.5rem;
        height: 1.5rem;
        background: #FF4D4F;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        border-radius: 50%;
        margin-left: 2rem;
      }
    }
  }
}
.content_one{
  &:last-child{
      .el-input{
        width: 80rem !important;
      }
  }
}
.content_last{
  margin-top: 2rem;
  display: flex;
  align-items: center;
  img{
    width: 1.7rem;
    height: 1.3rem;
    margin-right: 1.2rem;
  }
  .last_border{
    width: 90rem;
    background: #fff;
    border: 1px solid #E5E5EA;
    display: flex;
    align-items: center;
    height: 4rem;
    span{
      color: #666666;
      font-size: 1.4rem;
      margin-left:1.3rem;
    }
    .el-input{
      margin-left: 1.1rem;
      width: 78rem;
      ::v-deep .el-input__inner{
        height: 3rem !important;
        border-radius: 0.4rem;
      }
    }
  }
}
.input_textare{
  background: #E5E5EA;
  border-radius: 0.4rem;
  width:86rem;
  height: 4rem;
  margin-left: 2.7rem;
  margin-top: 2rem;
  color: #666666 !important;
  font-size: 1.4rem;
  display: flex;
  align-items: center;
  padding-left: 1.2rem;
}
.text_input{
  margin-left: 2.7rem;
  display: flex;
  align-items: center;
  margin-top: 2rem;
  .el-input{
     width: 82rem;
  }
  .content_one_img{
    width: 1.5rem;
    height: 1.5rem;
    background: #FF4D4F;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    border-radius: 50%;
    margin-left: 2rem;
  }         
}
.form_btns{
  margin-top: 2rem;
  display: flex;
  align-items: center;
  margin-left: 3rem;
  >div{
    cursor: pointer;
    &:nth-child(1){
      display: flex;
      align-items: center;
      margin-left: 2rem;
      img{
        width: 1.5rem;
        height: 1.5rem;
        border-radius: 50%;
      }
      span{
        margin-left: 1rem;
        color: #246DEB;
        font-size: 1.4rem;
      }
    }
    &:nth-child(2){
      display: flex;
      align-items: center;
      margin-left: 2rem;
      img{
        width: 1.5rem;
        height: 1.5rem;
        border-radius: 50%;
      }
      span{
        margin-left: 1rem;
        color: #666666;
        font-size: 1.4rem;
      }
    }
  }
}
.buttom_div{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 5rem;
    >div{
      cursor: pointer;
      height: 4rem;
      border-radius: 0.4rem;
      color: #fff;
      font-size: 1.4rem;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 10rem;
      &:nth-child(1){
        background: #D9D9D9;
      }
      &:nth-child(2){
        background: #246DEB;
        margin-left: 2rem;
      }
      &:nth-child(3){
        background: #246DEB;
        margin-left: 2rem;
      }
    }
}
.edit_box{
  width: 100%;
  display: flex;
  align-items: center;
  >div{
    width: 30rem;
    height: 65.2rem;
    border: 1px solid #E5E5EA;
    margin-right: 2rem;
    border-radius: 0.4rem;
    padding: 2rem;
    box-sizing: border-box;
    &:last-child{
      margin-right: 0;
    }
    >span{
      font-size: 1.6rem;
      color: #666666;
    }
    .edit_box_select{
      margin-top: 2rem;
      >div{
        display: flex;
        align-items: center;
        margin-bottom: 2rem;
        img{
          width: 1.7rem;
          height: 1.3rem;
          margin-right: 1.4rem;
        }
      }
    }
    .edit_box_btn{
      display: flex;
      margin-top: 2rem;
      align-items: center;
      >div{
        display: flex;
        align-items: center;
        margin-right: 2rem;
        cursor: pointer;
        img{
          width: 1.5rem;
          height: 1.5rem;
          border-radius: 50%;
        }
        span{
          margin-left: 1rem;
          color: #246DEB;
          font-size: 1.4rem;
        }
      }
    }
  }
}
.input_textare{
  ::v-deep .el-textarea__inner{
    width: 100%;
    height: 100%;
  }
}
::v-deep .el-dialog__body{
  padding: 0px 20px 20px;
}
::v-deep .el-divider--horizontal{
  margin: 0 0 20px 0;
}
</style>
